var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-title"},[_c('router-link',{staticClass:"app-title-router",attrs:{"to":"/"}},[_c('img',{staticClass:"app-title-logo",attrs:{"src":"img/logo.png","title":"自助制图系统"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }